const USERS_ENDPOINT = {
  USERS: '/users',
  RESET_PASSWORD: '/users/reset-password',
  START_FREE_TRIAL: '/users/start-free-trial'
}

const USERS_ACTION = {
  CREATE_AFTER_LOG_IN: 'USERS_CREATE_AFTER_LOG_IN',
  START_FREE_TRIAL: 'USERS_START_FREE_TRIAL',
  LOAD: 'USERS_LOAD',
  UPDATE_CURRENT: 'USERS_UPDATE_CURRENT',
  DELETE_CURRENT: 'USERS_DELETE_CURRENT',
  RESET_PASSWORD: 'USERS_RESET_PASSWORD',
  UPDATE: 'USERS_UPDATE'
}

const USERS_ANALYTICS_EVENT = {
  RESET_PASSWORD: 'Users Reset Password',
  START_FREE_TRIAL: 'Users Free Trial Started'
}

const USERS_DOMAIN = 'users'

const USERS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

const USERS_PATH = {
  ALL: `${USERS_DOMAIN}.${USERS_KEY.ALL}`,
  ALL_DATA: `${USERS_DOMAIN}.${USERS_KEY.ALL}.data`,
  CURRENT: `${USERS_DOMAIN}.${USERS_KEY.CURRENT}`,
  DATA: `${USERS_DOMAIN}.${USERS_KEY.DATA}`
}

const USERS_STATE = {
  [USERS_KEY.ALL]: {
    data: [],
    status: null
  },
  [USERS_KEY.CURRENT]: null,
  [USERS_KEY.DATA]: {}
}

export {
  USERS_KEY,
  USERS_ACTION,
  USERS_DOMAIN,
  USERS_PATH,
  USERS_STATE,
  USERS_ENDPOINT,
  USERS_ANALYTICS_EVENT
}
